import {} from './swiper.js';
import { gsap, DrawSVGPlugin, ScrollTrigger } from 'gsap/all';
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

export function mobileNavigation() {
  const toggle = document.querySelector('.hamburger');
  const body = document.body;
  const tl = gsap.timeline({ defaults: { ease: 'power2.inOut', duration: 0.5 }, paused: true, reversed: true })
    .to('.bar1', { duration: .1, width: '40px', height: '4px', top: '50%', left: '15%', rotate: '45deg' })
    .to('.bar2', { duration: .1, opacity: 0 }, '<')
    .to('.bar3', { duration: .1, width: '40px', height: '4px', top: '50%', left: '15%', rotate: '-45deg' }, '<')
    .to('.mobile-navigation-container', { duration: 0, width: '100%', ease: 'power4.in' }, '<');
  toggle.addEventListener('click', () => {
    body.classList.toggle('stop-scroll');
    tl.reversed() ? tl.play() : tl.reverse();
  });
}

// Scroll-triggered logo scaling
ScrollTrigger.saveStyles('.mobile, .desktop');
ScrollTrigger.matchMedia({
    '(min-width: 5px)': () => {
    const logo = gsap.to('header .wp-block-site-logo', {
        scale: 0.8,
        transformOrigin: '0% 0%',
        duration: 0.5,
        paused: true,
    });

    ScrollTrigger.create({
        start: 'top -50',
        end: 99999,
        onEnter: () => logo.play(),
        onLeaveBack: () => logo.reverse(),
    });
    },
});

// Mobiel submenu toggles
$('.hamburger li.has-child .wp-block-navigation-submenu__toggle').on('click', function (e) {
  e.preventDefault();
  const $el = $(this).parent('li');
  $el.toggleClass('open')
    .children('ul').slideToggle()
    .end().siblings('li').removeClass('open').find('ul').slideUp();
});

// Hide menu is search
document.addEventListener('click', function (e) {
  const searchButton = e.target.closest('.wp-block-search__button');
  const searchForm   = e.target.closest('.wp-block-search');
  const menu         = document.querySelector('.menu, .wp-block-navigation, [data-menu="primary"]');
  const w            = window.innerWidth;

  if (!menu) return;

  // Klik op de search button → verberg menu (alleen tussen 960–1120px)
  if (searchButton && w >= 960 && w <= 1120) {
    menu.classList.add('is-hidden');
    return;
  }

  // Klik buiten het zoekformulier → toon menu weer
  if (!searchForm && menu.classList.contains('is-hidden')) {
    menu.classList.remove('is-hidden');
  }
});

// Header scroll class
gsap.to('header .header', {
  duration: 0.2,
  scrollTrigger: {
    start: 'top -50',
    end: 99999,
    toggleActions: 'play none none reverse',
    toggleClass: { className: 'scrolled', targets: 'header.wp-block-template-part' },
  },
});

// Cover image animatie
gsap.timeline()
.fromTo('.coverHome .wp-block-cover__image-background',
  { scaleX: 1.15, scaleY: 1.15 },
  { scaleX: 1, scaleY: 1, transformOrigin: 'center center', duration: 1 })
.to('.coverHome .wp-block-cover__image-background', { scaleX: 1, scaleY: 1, duration: 1 });

// Schuinte
document.addEventListener('DOMContentLoaded', () => {
  const hoek = 7;
  const selectors = [
    '.is-style-indrukwekkend-schuin',
    '.is-style-group-schuin',
    '.indrukwekkend-bgkcolmns',
    '.is-style-group-schuinbgtop',
    '.wp-block-navigation__submenu-container',
    '.swiper-slide',
    '.showroom-badge',
    'li.description_tab.active',
    'li.brand_tab_tab.active',
    '.wc-tabs li.active',
    '.woocommerce-tabs .tabs li.active',
    'li.description_tab.active > a',
    'li.brand_tab_tab.active > a',
    '.wc-tabs li.active > a',
    '.woocommerce-tabs .tabs li.active > a',
  ].join(', ');
  const measureBox = (el) => {
    let rect = el.getBoundingClientRect();
    if ((rect.height === 0 || rect.width === 0) && el.firstElementChild) {
      rect = el.firstElementChild.getBoundingClientRect();
    }
    return rect;
  };
  const applyClip = (el) => {
    const { width: breedte, height: hoogte } = measureBox(el);
    if (hoogte <= 0 || breedte <= 0) return;
    const offset = Math.tan((hoek * Math.PI) / 360) * breedte;
    const percentage = (offset / hoogte) * 100;
    const poly = el.classList.contains('is-style-group-schuinbgtop')
      ? `polygon(0 ${percentage}%, 100% 0, 100% 100%, 0% 100%)`
      : `polygon(0 0, 100% 0, 100% calc(100% - ${percentage}%), 0% 100%)`;

    el.style.clipPath = poly;
    el.style.webkitClipPath = poly;
  };
  const refresh = () => {
    document.querySelectorAll(selectors).forEach(applyClip);
  };
  refresh();
  window.addEventListener('load', refresh);
  window.addEventListener('resize', refresh);
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.attributeName === 'class') {
        refresh();
        break;
      }
    }
  });
  mo.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class'] });
});

// Body class als er een cover image block aanwezig is
function updateBodyCoverClass() {
  const hasCover = !!document.querySelector('.coverHome');
  document.body.classList.toggle('coverTop', hasCover);
}
document.addEventListener('DOMContentLoaded', updateBodyCoverClass);

// Height header
document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const header = document.querySelector('.header');
  const main = document.querySelector('main.wp-block-group');
  const applyPadding = () => {
    if (body.classList.contains('coverTop')) {
      main.style.paddingTop = '';
      document.documentElement.style.removeProperty('--header-h');
      return;
    }
    const h = Math.ceil(header.getBoundingClientRect().height);
    const adminbar = document.getElementById('wpadminbar');
    const extra = adminbar ? adminbar.getBoundingClientRect().height : 0;
    const total = h + extra + 50;
    main.style.paddingTop = total + 'px';
    document.documentElement.style.setProperty('--header-h', total + 'px');
  };

  applyPadding();
  window.addEventListener('resize', applyPadding);
  const ro = new ResizeObserver(applyPadding);
  ro.observe(header);
  const mo = new MutationObserver(applyPadding);
  mo.observe(body, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('load', applyPadding);
});

// Voeg event-tracking toe aan je knoppen
document.addEventListener('click', function(e) {
  const el = e.target.closest('.button-A, .button-B');
  if (!el) return;
  let variant = el.classList.contains('button-A') ? 'A' : 'B';
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'cta_click', {
      experiment: 'button',
      variant: variant,
      url: el.href || null,
    });
  }
  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({
      event: 'cta_click',
      experiment: 'button',
      variant: variant,
      url: el.href || null,
    });
  }
});

// Formulier aanvraag single product
(function initContactPanel(){
  if (!document.body.classList.contains('single-product')) return;

  const triggerKorting = document.querySelector('.contactpanel-trigger');
  const triggerInruil  = document.querySelector('.inruilpanel-trigger');

  const panel   = document.getElementById('ie-contactpanel');
  const overlay = document.querySelector('.ie-contactpanel-overlay');
  const closeBtn = panel ? panel.querySelector('.ie-contactpanel-close') : null;

  if (!panel || !overlay || !closeBtn || (!triggerKorting && !triggerInruil)) return;

  const titleKorting = panel.querySelector('#ie-contactpanel-title-korting');
  const titleInruil  = panel.querySelector('#ie-contactpanel-title-inruil');
  const contentKorting = panel.querySelector('.ie-contactpanel-content--korting');
  const contentInruil  = panel.querySelector('.ie-contactpanel-content--inruil');

  function setVariant(variant){
    const isKorting = variant === 'korting';
    panel.dataset.variant = variant;

    // Titels tonen/verbergen + aria-labelledby updaten
    if (titleKorting && titleInruil) {
      titleKorting.hidden = !isKorting;
      titleInruil.hidden  =  isKorting;
      panel.setAttribute('aria-labelledby', isKorting ? 'ie-contactpanel-title-korting' : 'ie-contactpanel-title-inruil');
    }

    // Inhoud tonen/verbergen
    if (contentKorting && contentInruil) {
      contentKorting.hidden = !isKorting;
      contentInruil.hidden  =  isKorting;
    }
  }

  function openPanel(e, variant){
    if (e) e.preventDefault();
    setVariant(variant || 'korting');
    panel.classList.add('is-open');
    overlay.hidden = false;
    document.documentElement.classList.add('ie-noscroll');
    document.body.classList.add('ie-noscroll');
  }

  function closePanel(){
    panel.classList.remove('is-open');
    overlay.hidden = true;
    document.documentElement.classList.remove('ie-noscroll');
    document.body.classList.remove('ie-noscroll');
  }

  if (triggerKorting) triggerKorting.addEventListener('click', (e) => openPanel(e, 'korting'));
  if (triggerInruil)  triggerInruil.addEventListener('click',  (e) => openPanel(e, 'inruil'));

  closeBtn.addEventListener('click', closePanel);
  overlay.addEventListener('click', closePanel);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
  });
})();

// Koffiebonen
(function(){
  const prefersReduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ensureLayer(){
    let layer = document.querySelector('.coffee-rain');
    if(!layer){
      layer = document.createElement('div');
      layer.className = 'coffee-rain';
      Object.assign(layer.style, {
        position:'fixed', inset:'0', pointerEvents:'none', overflow:'hidden', zIndex:'9999',
      });
      document.body.appendChild(layer);
    }
    return layer;
  }
  window.coffeeRain = function(opts={}){
    if(prefersReduced) return;
    const {
      count = 24,
      durMin = 3,
      durMax = 5,
    } = opts;
    const layer = ensureLayer();
    for(let i=0; i<count; i++){
      const bean = document.createElement('div');
      bean.className = 'coffee-rain__bean';
      Object.assign(bean.style, {
        position:'absolute', top:'-80px', width:'26px', height:'26px', opacity:'0',
        background: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 24 24\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cellipse cx=\'12\' cy=\'12\' rx=\'9\' ry=\'12\' fill=\'%238B5A2B\'/%3E%3Cpath d=\'M12 3c-1 5 1 13 0 18\' stroke=\'%232a1a0a\' stroke-width=\'2\' fill=\'none\' stroke-linecap=\'round\'/%3E%3C/svg%3E") center/contain no-repeat',
      });
      layer.appendChild(bean);
      const x = gsap.utils.random(0, window.innerWidth-24, 1);
      const rot = gsap.utils.random(-180,180);
      gsap.set(bean, {x, opacity:1, rotation:rot});
      gsap.to(bean, {
        duration: gsap.utils.random(durMin, durMax),
        y: window.innerHeight + 60,
        rotation: rot + gsap.utils.random(-90,90),
        ease: 'power1.in',
        onComplete: () => bean.remove(),
      });
    }
  };
})();

// Koffiebonen afvuren op alleen de bedanktpagina's
(function(){
  const prefersReduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(prefersReduced) return;
  const THANKYOU_PATHS = [
    '/bedankt',
    '/bedankt-brochure',
    '/bedankt-inruilaanvraag',
    '/bedankt-inschrijving',
    '/bedankt-prijsaanvraagt',
  ];
  const path = location.pathname.toLowerCase();
  const search = location.search.toLowerCase();
  const matchByPath = THANKYOU_PATHS.some(p => path.includes(p));
  const matchByQuery = /(\?|&)(thank(_|-)?you|success|ok|done|gform_submit|wpcf7|sent|submitted)(=|&|$)/i.test(search);
  if (matchByPath || matchByQuery) {
    setTimeout(() => {
      if (typeof window.coffeeRain === 'function') {
        window.coffeeRain({ count: 80, durMin: 1.3, durMax: 2.2 });
      }
    }, 600);
  }
})();

// Afrekenknop deactiveren indien niet minimun aantal
document.addEventListener('DOMContentLoaded', function () {
  function updateCheckoutButton(button) {
      if (!button) return;

      var href = (button.getAttribute('href') || '').trim();
      var isPlaceholder = (href === './#' || href === '#');

      if (isPlaceholder) {
          // Uitschakelen
          button.classList.add('is-disabled');
          button.setAttribute('aria-disabled', 'true');
          button.setAttribute('tabindex', '-1');
      } else {
          // Activeren
          button.classList.remove('is-disabled');
          button.removeAttribute('aria-disabled');
          button.removeAttribute('tabindex');
      }
  }

  function initCheckoutWatcher() {
      var button = document.querySelector('a.wc-block-cart__submit-button');
      if (!button) {
          return;
      }

      // Eerste update
      updateCheckoutButton(button);

      // Observer: volg veranderingen aan het href-attribuut
      var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
              if (
                  mutation.type === 'attributes' &&
                  mutation.attributeName === 'href' &&
                  mutation.target === button
              ) {
                  updateCheckoutButton(button);
              }
          });
      });

      observer.observe(button, {
          attributes: true,
          attributeFilter: ['href'],
      });
  }

  // Direct proberen te initialiseren
  initCheckoutWatcher();

  // Voor het geval Woo Blocks de knop later inlaadt/her-rendert:
  var bodyObserver = new MutationObserver(function (mutations) {
      var found = false;

      mutations.forEach(function (mutation) {
          if (mutation.type === 'childList') {
              // Nieuwe nodes checken
              Array.prototype.forEach.call(mutation.addedNodes, function (node) {
                  if (node.nodeType === 1) {
                      if (
                          (typeof node.matches === 'function' && node.matches('a.wc-block-cart__submit-button')) ||
                          (typeof node.querySelector === 'function' && node.querySelector('a.wc-block-cart__submit-button'))
                      ) {
                          found = true;
                      }
                  }
              });
          }
      });

      if (found) {
          initCheckoutWatcher();
      }
  });

  bodyObserver.observe(document.body, {
      childList: true,
      subtree: true,
  });
});

// Add to cart quantity + WooCommerce blocks update
document.addEventListener('click', function(e) {
  const minusBtn = e.target.closest('.fwpl-qty-minus');
  const plusBtn = e.target.closest('.fwpl-qty-plus');
  const addToCartBtn = e.target.closest('.fwpl-add-to-cart .ajax_add_to_cart');

  if (!minusBtn && !plusBtn && !addToCartBtn) {
    return;
  }

  const wrapper = e.target.closest('.fwpl-add-to-cart');

  if (!wrapper) {
    return;
  }

  const qtyInput = wrapper.querySelector('.fwpl-qty');
  const cartBtn = wrapper.querySelector('.ajax_add_to_cart');

  if (!qtyInput) {
    return;
  }

  if (minusBtn || plusBtn) {
    const min = parseFloat(qtyInput.getAttribute('min')) || 1;
    const max = parseFloat(qtyInput.getAttribute('max')) || 9999;
    const step = parseFloat(qtyInput.getAttribute('step')) || 1;

    let value = parseFloat(qtyInput.value) || min;

    if (plusBtn) {
      value += step;
    }

    if (minusBtn) {
      value -= step;
    }

    value = Math.max(min, Math.min(max, value));

    qtyInput.value = value;
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  if (cartBtn) {
    cartBtn.setAttribute('data-quantity', qtyInput.value || 1);
  }
});

// Refresh WooCommerce mini cart / cart block number
jQuery(function($) {
  $(document.body).on('added_to_cart', function() {
    document.body.dispatchEvent(
      new CustomEvent('wc-blocks_added_to_cart', {
        bubbles: true,
        detail: {
          preserveCartData: false,
        },
      })
    );
  });
});